// extracted by mini-css-extract-plugin
module.exports = {"container":"_2yn7m","userInfo":"_1aIpc","userIcon":"_1RgYi","tooltipContent":"_1u3Up","userItem":"PVCeT","avatarIcon":"_2MU7d","button":"_2poFS","hidden":"_3E6Pv"};